<template>
  <vs-chip :color="badgeContext">{{ badgeContent }}</vs-chip>
</template>

<script>
export default {
  name: 'BadgeIsActive',
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    badgeContent () {
      switch (this.isActive) {
      case true:
        return this.$t('in_use')
      default:
        return this.$t('unused')
      }
    },
    badgeContext () {
      switch (this.isActive) {
      case true:
        return 'success'
      default:
        return 'danger'
      }
    }
  }
}
</script>

<style scoped>

</style>
